/* RESPONSIBLE TEAM: team-ml */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type Transition from '@ember/routing/transition';

class AutomationFinAIAgentSdrConfiguratorRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare permissionsService: $TSFixMe;

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      'can_create_and_edit_bots',
      transition,
    );

    if (!this.appService.app.canUseFeature('sdr-ai-configurator')) {
      return this.router.transitionTo('apps.app.automation.fin-ai-agent.sales-development');
    }
    return;
  }
}

export default ReactRoute(AutomationFinAIAgentSdrConfiguratorRoute);
